'use client';

import InnerLayout from '~/components/InnerLayout';
import ElectionMenu from '~/components/ElectionMenu';
import SlagPreview from './SlagPreview/SlagPreview';
import RegionPreview from './RegionPreview/RegionPreview';
import { observer } from 'mobx-react';
import { getStore } from '~/mobx/AppStore';

type Props = {
    isCompany: boolean;
};

const Preview = (props: Props) => {
    const { isCompany } = props;

    const renderMainContent = () => {
        return isCompany ? <SlagPreview /> : <RegionPreview />;
    };

    return <InnerLayout className="preview-page" leftPanel={<ElectionMenu />} content={renderMainContent()} />;
};

const PreviewWithStore = () => {
    const { electionMenuStore } = getStore();
    const isCompany = electionMenuStore.getIsCompanyLevel();

    return <Preview isCompany={isCompany} />;
};

export default observer(PreviewWithStore);
